<template>
  <div class="auth-container password-reset-container">
    <img class="logo" alt="Feeds.automated logo" src="/app/images/logo.svg" />
    <div class="w-75 my-4">
      <p class="text-center paragraph-content paragraph-big">{{ $t('auth.password_reset_1') }}</p>
      <p class="text-center paragraph-content paragraph-big">{{ $t('auth.password_reset_2') }} <a href="mailto:feeds@bluerank.com" target="_blank"><strong>feeds@bluerank.com</strong></a></p>
    </div>
    <router-link :to="{ name: 'auth.login'}">
      <button type="button" class="btn btn-medium btn-orange">{{ $t('auth.back_to_login') }}</button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'PasswordReset',

  mounted () {
    window.addEventListener('keypress', (e) => {
      if (e.keyCode === 13) this.$router.push({ name: 'auth.login' })
    })
  }
}
</script>
